import { cn } from "@/lib/utils";

import Logo from "./Logo";
import LogoType from "./LogoType";

export default function HiraLogo({ className }: { className?: string }) {
  return (
    <div className={cn("flex items-center gap-x-[5px]", className)}>
      <Logo />
      <LogoType />
    </div>
  );
}
